module.exports = __webpack_public_path__ + "img/case-ct_capsule_top.3b5f46b.png";